export { dashboardResolver } from './dashboard.resolver.fn';
export { projectResolver, ProjectResolverData } from './project.resolver.fn';
export { scenarioFormResolver, ScenarioFormResolverData } from './scenario-form.resolver.fn';
export { scenarioViewResolver, ScenarioViewResolverData } from './scenario-view.resolver.fn';
export { scenarioResolver } from './scenario.resolver.fn';

// Re-export interfaces from @model for backward compatibility
export { ScenarioResolverResult, ScenarioResolverData } from '@model';
